import { useState } from 'react';
import { useEffect } from 'react';

const useScript = (url, async) => {

  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {

    async function loadScript(script) {
        
      document.head.appendChild(script);

      script.loaded = new Promise((resolve) => {
        script.onload = () => { resolve(); };
      });

      await Promise.all([script.loaded]);

      setScriptLoaded(true);
    }

    const script = document.createElement('script');
    script.src = url;
    script.async = (typeof async === 'undefined' ? true : async );

    loadScript(script);

    return () => {
      document.head.removeChild(script);
    }
  }, [url, async])

  return [scriptLoaded];
}

function Script({ src, async=true}) {

    useScript(src, async);

    return null;  // Return null is necessary for the moment.
}

export {Script, useScript};

